import React from 'react';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Container, Typography, useMediaQuery } from '@material-ui/core';

import { Link } from 'react-scroll';

import Divider from './Divider';
import ScrollDownChevron from './ScrollDownChevron';
import { screenWidthSettings } from '../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '60vh',
      minHeight: '425px',
      maxHeight: '100vh',
      position: 'relative',
    },
    coverPhoto: {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
    textContainer: {
      color: 'white',
      width: '100vw',
      maxWidth: screenWidthSettings.maxScreenWidth,
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(0,0,0,0.5)',
    },
    headerTop: {
      height: '55%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      [theme.breakpoints.down(425)]: {
        height: '35%',
      },
    },
    title: {
      fontFamily: "'Titillium Web', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 600,
    },
    headerBot: {
      // height: '45%',
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
    },
    headerStatement: {
      maxWidth: '800px',
      background:
        'linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0.6) 25%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.6) 75%,rgba(0,0,0,0))',
      padding: '1rem',
    },
  })
);

interface Props {
  title: string;
  coverPhoto: any;
  headerStatement: string;
  dividerColor: string;
  scrollToElementID: string;
}

const PageHeader = (props: Props) => {
  const classes = useStyles();
  const isMobileScreen = useMediaQuery(
    `(max-width:${screenWidthSettings.mobileScreenSize}px)`
  );
  const isLaptopScreen = useMediaQuery(
    `(max-width:${screenWidthSettings.laptopScreenSize}px)`
  );
  return (
    <div className={classes.root}>
      <img className={classes.coverPhoto} src={props.coverPhoto} alt='' />
      <Container className={classes.textContainer}>
        <div className={classes.headerTop}>
          <Typography
            align='center'
            variant={isLaptopScreen ? 'h2' : 'h1'}
            component='h1'
            className={classes.title}
          >
            {props.title}
          </Typography>
          <Divider color={props.dividerColor} />
        </div>
        <div className={classes.headerBot}>
          <Typography
            align='center'
            variant={isMobileScreen ? 'h6' : isLaptopScreen ? 'body1' : 'h6'}
            component='h2'
            className={classes.headerStatement}
          >
            {props.headerStatement}
          </Typography>
        </div>
        <Link to={props.scrollToElementID} duration={500} smooth={true}>
          <ScrollDownChevron chevronColor={props.dividerColor} />
        </Link>
      </Container>
    </div>
  );
};

export default PageHeader;
